<template>
	<div>
		<client-module class="header-title" :moduletitle="moduletitle" hideBorder>
			<filter-panel style="width: 100%;" :data="group" @search="filterChange"></filter-panel>
		</client-module>
		<data-list
			:table-style="{ name: 'mixture' }"
			:data="data"
			:columns="columns"
			:loading="loading"
			:btnList="btnList"
			:custom="custom"
			:hint="hint"
			:page="page"
			:page-size="page.pageSize"
			@page-size-changed="pageSizeChanged"
			@page-changed="pageChanged"
			@sort-change="sortChange"
		></data-list>
		<dialog-form
			:dialogVisible="showDialog"
			:attributes="attributes"
			:formData="formData"
			@close:dialogVisible="
				val => {
					showDialog = val;
				}
			"
			@confirm="confirm"
		></dialog-form>
	</div>
</template>

<script>
import garbageInquiry from '@/backend/services/garbageInquiry/garbageInquiry.js';
import clientModule from '@/components/client/clientModule/clientModule.vue';
import dialogForm from '@/components/dialogForm/dialogForm';
import { validRequired } from '@/common/elementValid.js';
import listPageCreate from '@/mixins/listPageCreate';
import api from '@/backend/apiConfig/apiConfig';
import filterPanel from '@/components/iglobalwin/filterPanelNew/filterPanel.vue';
const list = listPageCreate({
	searchConfig: {
		api: api.garbageInquiry.filterRuleList,
		method: 'POST',
	},
	getQuery(object, that) {
		let type = that.$route.query.type === 1 ? 4 : 5;
		return _.assign(object, {
			type,
		});
	},
});
export default {
	mixins: [list],
	data() {
		return {
			moduletitle: '',
			columns: [],
			btnList: [],
			custom: {},
			hint: {},
			attributes: {
				title: '新增过滤规则',
			},
			showDialog: false,
			formData: {},
			updateId: '',
			group: {
				others: [
					{
						tagName: 'sky-input',
						placeholder: '关键词',
						label: '关键词',
						prop: 'keyword',
						value: '',
					},
				],
			},
		};
	},
	mounted() {
		this.setColumns();
		this.query();
	},
	methods: {
		setColumns() {
			let name = ['邮件地址', '邮件内容'];
			let { type } = this.$route.query;
			this.moduletitle = `${name[type - 1]}白名单`;
			let that = this;
			if (type === 1) {
				this.columns = [
					{
						label: '地址',
						bind: 'content',
						showOverflowTooltip: true,
					},
					{
						label: '备注',
						bind: 'remarks',
						showOverflowTooltip: true,
					},
					{
						label: '操作',
						type: 'btnClick',
						bind: [
							{
								text: '编辑',
								trigger(row) {
									that.showDialog = true;
									that.setFormData(row);
								},
							},
							{
								text: '移除',
								async trigger(row) {
									let res = await garbageInquiry.deleteFilterRule({
										id: row.id,
										type: 0, //0否1是
									});
									if (res.status == 200) {
										that.$message.success('移除成功');
										that.query();
									}
								},
							},
						],
					},
				];
			} else {
				this.columns = [
					{
						label: '内容',
						bind: 'content',
						showOverflowTooltip: true,
					},
					{
						label: '添加时间',
						bind: 'createTime',
						showOverflowTooltip: true,
					},
					{
						label: '添加人',
						bind: 'createrName',
						showOverflowTooltip: true,
					},
					{
						label: '操作',
						type: 'btnClick',
						bind: [
							{
								text: '编辑',
								trigger(row) {
									that.showDialog = true;
									that.setFormData(row);
								},
							},
							{
								text: '移除',
								async trigger(row) {
									let res = await garbageInquiry.deleteFilterRule({
										id: row.id,
										type: 0, //0否1是
									});
									if (res.status == 200) {
										that.$message.success('移除成功');
										that.query();
									}
								},
							},
						],
					},
				];
			}
			this.btnList = [
				{
					name: '新增',
					position: 'right',
					attribute: {
						type: 'primary',
					},
					btnClick() {
						that.setFormData();
						that.showDialog = true;
					},
				},
			];
			this.hint = {
				content: '',
			};
		},
		setFormData(obj = {}) {
			this.updateId = obj.id;
			let { type } = this.$route.query;
			if (type === 1) {
				this.formData = {
					content: {
						label: '地址',
						formType: 'sky-input',
						value: obj.content,
						rules: [validRequired('此项必填')],
					},
					remarks: {
						label: '备注',
						formType: 'sky-textarea',
						autosize: { minRows: 2 },
						value: obj.remarks,
						rules: [validRequired('此项必填')],
					},
				};
			} else {
				this.formData = {
					content: {
						label: '邮件内容',
						formType: 'sky-textarea',
						autosize: { minRows: 2 },
						value: obj.content,
						rules: [validRequired('此项必填')],
					},
				};
			}
		},
		// 确定
		async confirm(cb) {
			try {
				let { formData, updateId } = this;
				let { type } = this.$route.query;
				let res = await garbageInquiry.addFilterRule({
					content: formData.content.value,
					remarks: formData.remarks ? formData.remarks.value : '',
					type: type === 1 ? 4 : 5,
					id: updateId,
				});
				if (res.status === 200) {
					let message = updateId ? '编辑成功' : '新增成功';
					this.$message.success(message);
					this.query();
					cb();
				}
			} catch (error) {
				console.log(error);
				cb(false);
			}
		},
	},
	watch: {
		page: {
			handler(val) {
				this.hint = {
					content: `总计：${val.totalRecords}条`,
				};
			},
			deep: true,
			immediate: true,
		},
	},
	components: { clientModule, dialogForm, filterPanel },
};
</script>

<style lang="scss" scoped>
.header-title {
  background-color: #fff;
}
</style>
